/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiErrorResponseErrorFromJSON, StreemApiErrorResponseErrorToJSON, } from './';
export function StreemApiErrorResponseFromJSON(json) {
    return StreemApiErrorResponseFromJSONTyped(json, false);
}
export function StreemApiErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'httpCode': !exists(json, 'http_code') ? undefined : json['http_code'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'error': !exists(json, 'error') ? undefined : StreemApiErrorResponseErrorFromJSON(json['error']),
    };
}
export function StreemApiErrorResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'http_code': value.httpCode,
        'message': value.message,
        'error': StreemApiErrorResponseErrorToJSON(value.error),
    };
}
//# sourceMappingURL=StreemApiErrorResponse.js.map